// removed by extract-text-webpack-plugin
module.exports = {"container":"n8_g","button":"n8_bp","avatar":"n8_fm","signOut":"n8_n9"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/UserMenu/components/UserMenuLoggedIn/styles.module.css
// module id = 1086
// module chunks = 27